export const TEXT = {
  DESCRIPTION: {id: 'myLK.order.schedule_title'},
  CTA: {id: 'myLK.order.schedule_button_select'},
};
export const IDS = {
  SAVE_DAY_BUTTON: 'CalendarDatescta',
};
